<template>
  <div class="keyboard-component">
    <div :class="id" class="simple-keyboard"></div>
  </div>
</template>

<script>
  import Keyboard from 'simple-keyboard'
  import 'simple-keyboard/build/css/index.css'
  import './index.less'

  export default {
    name: 'Keyboard',
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: [String, Number],
        default: '',
      },
      id: {
        type: String,
        default: 'simple-keyboard',
      },
      closable: Boolean,
    },
    data () {
      return {
        keyboard: null,
        layout: {
          default: [
            'й ц у к е н г ш щ з х ъ {bksp}',
            'ф ы в а п р о л д ж э {enter}',
            '{shift} я ч с м и т ь б ю , .',
            '{alt} {space}',
          ],
          shift: [
            'Й Ц У К Е Н Г Ш Щ З Х Ъ {bksp}',
            'Ф Ы В А П Р О Л Д Ж Э {enter}',
            '{shiftactivated} Я Ч С М И Т Ь Б Ю , .',
            '{alt} {space}',
          ],
          alt: [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            '@ # $ & * ( ) \' " {enter}',
            '{shift} % - + = / ; : ! ?',
            '{default} {space}',
          ],
        },
        display: {
          '{alt}': '.?123',
          '{smileys}': '\uD83D\uDE03',
          '{shift}': '⇧',
          '{shiftactivated}': '⇧',
          '{enter}': 'Enter',
          '{bksp}': '⌫',
          '{altright}': '.?123',
          '{downkeyboard}': '✖',
          '{space}': ' ',
          '{default}': 'ABC',
          '{back}': '⇦',
        },
      }
    },
    watch: {
      value () {
        this.keyboard.setInput(this.value)
        this.$emit('input', this.value)
      },
    },
    computed: {
      getLayout () {
        if (this.closable) {
          const defaultLayout = this.layout.default
          defaultLayout[defaultLayout.length - 1] += ' {downkeyboard}'
          const altLayout = this.layout.alt
          altLayout[altLayout.length - 1] += ' {downkeyboard}'
          const shiftLayout = this.layout.shift
          shiftLayout[shiftLayout.length - 1] += ' {downkeyboard}'
          return {
            default: defaultLayout,
            alt: altLayout,
            shift: shiftLayout,
          }
        }
        return this.layout
      },
    },
    methods: {
      onChange (input) {
        this.$emit('input', input)
      },
      onKeyPress (button) {
        if (button.includes('{downkeyboard}')) {
          this.$emit('onClose')
          return
        }
        if (button.includes('{') && button.includes('}')) {
          this.handleLayoutChange(button)
        }
      },
      handleLayoutChange (button) {
        const currentLayout = this.keyboard.options.layoutName
        let layoutName

        switch (button) {
          case '{shift}':
          case '{shiftactivated}':
          case '{default}':
            layoutName = currentLayout === 'default' ? 'shift' : 'default'
            break

          case '{alt}':
            layoutName = currentLayout === 'alt' ? 'default' : 'alt'
            break

          default:
            break
        }

        if (layoutName) {
          this.keyboard.setOptions({
            layoutName: layoutName,
          })
        }
      },
    },
    mounted () {
      this.keyboard = new Keyboard(`.${this.id}`, {
        onChange: (input) => this.onChange(input),
        onKeyPress: (button) => this.onKeyPress(button),
        theme: 'simple-keyboard hg-theme-default hg-theme-ios',
        layout: this.getLayout,
        display: this.display,
      })
      if (this.value && this.value.length) {
        this.keyboard.setInput(this.value)
      }
    },
  }
</script>

<style lang="less" scoped>
.keyboard-component {
  margin-left: -8px;
  margin-right: -8px;
}
</style>
